import { Component, Input } from "@angular/core"

@Component({
  selector: "c1-privacy-title-banner",
  templateUrl: "./title-banner.component.html",
  styleUrls: ["./title-banner.component.scss"],
  standalone: false,
})
export class TitleBannerComponent {
  @Input() title: string
  @Input() subtitle: string
  @Input() banner1: string
  @Input() banner2: string
  @Input() bannerLinkText: string
  @Input() bannerLink: string
  @Input() description: string
  @Input() link: string
}
